import { cn } from '@/lib/utils';

interface WordmarkProps {
  className?: string;
  /** Use light variant on dark surfaces. */
  variant?: 'ink' | 'bone';
}

/**
 * Haphe wordmark. Geist Sans medium, tight tracking, one tiny moss dot on the 'e'.
 * The dot is the haphe — the joint that connects.
 */
export function Wordmark({ className, variant = 'ink' }: WordmarkProps) {
  const color = variant === 'ink' ? 'text-ink' : 'text-bone';
  const dot = variant === 'ink' ? 'bg-accent' : 'bg-accent-glow';
  return (
    <div className={cn('inline-flex items-end gap-[3px] font-sans font-medium', color, className)}>
      <span className="tracking-tightest">Haphe</span>
      <span className={cn('mb-[7px] block h-[5px] w-[5px] rounded-full', dot)} aria-hidden="true" />
    </div>
  );
}
